import React, {useState} from 'react';

import styles from './fields.module.scss';

import _ from "lodash";
import dateformat from "dateformat";

import cx from "classnames";
import TruncatedTextWithTooltip from 'components/TruncatedTextWithTooltip';


export default function CustomFieldItem ({onClick, onDelete, customField, fieldSelected}) {
  
  return (
    <div className={cx(cx(styles.customField, {[styles.customFieldBackground] : fieldSelected}))}>
      <div className={styles.fieldName} onClick={onClick}>
        <i className='cleverstory-list-field'/>
        <TruncatedTextWithTooltip content={customField.name} className={styles.name} maxWidth={200} placement='top'/>
        <span className={styles.modifiedDate}> Updated on : {dateformat(customField ? customField.modifiedDate : null, 'dd mmm yyyy')} </span> 
        {!_.isUndefined(customField.id) &&
          <span><i className={cx(styles.deleteField,'cleverstory-trash')} onClick={onDelete}/></span>
        }
      </div>
    </div>
  )
}